import { HTTPRequestMethod } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';
import type { NodeDataT } from 'fable/flowEditor';

import type {
  FlowChatActionT,
  FlowChatAddFlowPayloadT,
  FlowChatGetFlowPayloadT,
  FlowChatUpdateFlowPayloadT,
} from './types';

const base = '/v1/flows';

export function addFlow(payload: FlowChatAddFlowPayloadT) {
  return ajaxSend<NodeDataT<FlowChatActionT[]>>({
    method: HTTPRequestMethod.Post,
    path: base,
    data: payload.flow,
  });
}

export function getFlow(payload: FlowChatGetFlowPayloadT) {
  return ajaxSend<NodeDataT<FlowChatActionT[]>>({
    path: `${base}/${payload.id}`,
  });
}

export function updateFlow(payload: FlowChatUpdateFlowPayloadT) {
  return ajaxSend<NodeDataT<FlowChatActionT[]>>({
    method: HTTPRequestMethod.Put,
    path: `${base}/${payload.id}`,
    data: payload.flow,
  });
}
